import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalOverlay } from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import DatePicker from "react-datepicker";
import moment from "moment";
import { apiAccessTokenHistory } from "api/api_access";
import { MdHighlightOff } from "react-icons/md";
import { TbHistory } from "react-icons/tb";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";
import {
  createColumnHelper, flexRender, getCoreRowModel,
  getExpandedRowModel, getSortedRowModel, SortingState, useReactTable,
} from "@tanstack/react-table";

const columnHelper = createColumnHelper<any>();

function CrerateAPIAccessFilter(props: {
  fetchAllsettlement: () => void;
  roleData: any;
  info: any;
}) {
  const { fetchAllsettlement, roleData, info } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [filterFormData, setFilterFormData] = useState<any>({});
  const [isCloseModal, setIsCloseModal] = useState<boolean>(false);
  const [historyResponse, setHistoryResponse] = useState<any>([]);
  const [hData, setHData] = useState<any>([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [sorting, setSorting] = React.useState<SortingState>([]);

  const handleClose = () => {
    setFilterFormData({});
    setHistoryResponse([]);
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  const handleClickFunction = () => {
    onOpen();
    setHistoryLoading(true);
    apiAccessTokenHistory({ token_id: info?.row?.original?.id })
      .then((res: any) => { setHistoryResponse(res.token_history); setHistoryLoading(false); })
      .catch(() => setHistoryLoading(false));
  };

  useEffect(() => {
    if (Array.isArray(historyResponse)) setHData(historyResponse);
  }, [historyResponse]);

  useEffect(() => {
    if (filterFormData?.ending_date && filterFormData?.starting_date) {
      const filtered = historyResponse?.filter((f: any) => (
        moment(filterFormData.starting_date).format("YYYY-MM-DD") <= moment(f?.time).format("YYYY-MM-DD") &&
        moment(filterFormData.ending_date).format("YYYY-MM-DD") >= moment(f?.time).format("YYYY-MM-DD")
      ));
      setHData(filtered);
    } else {
      setHData(historyResponse);
    }
  }, [filterFormData?.ending_date]);

  const LABEL_MAP: Record<string, string> = {
    "view_fiat_payout_list": "View Fiat Batch Payout List",
    "view_crypto_payout_list": "View Crypto Batch Payout List",
  };

  const columns = [
    columnHelper.accessor("name", {
      id: "name",
      header: () => <span className="ach-th">Token Name</span>,
      cell: () => <span className="ach-cell-text">{info?.row?.original?.name}</span>,
      enableSorting: false,
    }),
    columnHelper.accessor("apiName", {
      id: "apiName",
      header: () => <span className="ach-th">API Endpoint</span>,
      cell: (info2) => {
        const value = info2.getValue() as string | undefined;
        const display = (value && LABEL_MAP[value.toLowerCase()]) ?? value?.replace(/_/g, " ");
        return <span className="ach-api-name">{display}</span>;
      },
    }),
    columnHelper.accessor("apiType", {
      id: "apiType",
      header: () => <span className="ach-th">API Type</span>,
      cell: (info2) => {
        const value = info2.getValue() as string | undefined;
        return <span className="ach-api-name">{value ?? "-"}</span>;
      },
    }),
    columnHelper.accessor("time", {
      id: "date",
      header: () => <span className="ach-th">Date</span>,
      cell: (info2) => <span className="ach-cell-text">{moment(info2.getValue()).format("YYYY-MM-DD")}</span>,
    }),
    columnHelper.accessor("time", {
      id: "time",
      header: () => <span className="ach-th">Time</span>,
      cell: (info2) => <span className="ach-cell-text">{moment(info2.getValue()).format("HH:mm:ss")}</span>,
    }),
  ];

  const table = useReactTable({
    data: hData,
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
  });

  return (
    <>
      <Popover trigger="hover" placement="bottom">
        <PopoverTrigger>
          <button className="ach-trigger-btn" onClick={handleClickFunction} aria-label="View history">
            <TbHistory size={15}/>
          </button>
        </PopoverTrigger>
        <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" bg="#eff6ff" maxW="200px" p="0" overflow="hidden" zIndex="20">
          <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="12px" py="9px">
            API Call History
          </PopoverHeader>
          <PopoverArrow bg="#eff6ff"/>
        </PopoverContent>
      </Popover>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)"/>
        <div className={`ach-panel${isOpen && !isCloseModal ? " ach-panel--open" : " ach-panel--close"}`}>

          <div className="ach-top-glow"/>

          {/* Header */}
          <div className="ach-header">
            <div className="ach-header-brand">
              <div className="ach-header-logo">
                <TbHistory size={19} color="#fff"/>
              </div>
              <div>
                <h2 className="ach-header-title">API Call History</h2>
                <p className="ach-header-sub">{info?.row?.original?.name}</p>
              </div>
            </div>
            <button className="ach-close-btn" onClick={handleClose} aria-label="Close">
              <MdHighlightOff size={22}/>
            </button>
          </div>

          {/* Body */}
          <div className="ach-body">
            {/* Filters */}
            <div className="ach-filters">
              <div className="ach-filter-section">
                {/* <div className="ach-filter-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </div> */}
                <div className="ach-filter-content">
                  <label className="ach-filter-label">Date Range Filter</label>
                  <div className="ach-datepicker-wrap">
                    <DatePicker
                      onKeyDown={(e) => e.preventDefault()}
                      className="ach-datepicker"
                      placeholderText="Select date range…"
                      startDate={filterFormData?.starting_date ? new Date(filterFormData.starting_date) : null}
                      endDate={filterFormData?.ending_date ? new Date(filterFormData.ending_date) : null}
                      selectsRange={true}
                      isClearable={true}
                      maxDate={new Date()}
                      onChange={(dateRange: any) => {
                        const [a, b] = dateRange;
                        setFilterFormData((p: any) => ({ ...p, starting_date: a, ending_date: b }));
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Stats bar */}
            <div className="ach-stats">
              <div className="ach-stat">
                <span className="ach-stat-label">Active Range</span>
                <span className="ach-stat-value">
                  {filterFormData?.starting_date && filterFormData?.ending_date
                    ? `${moment(filterFormData.starting_date).format("YYYY-MM-DD")} → ${moment(filterFormData.ending_date).format("YYYY-MM-DD")}`
                    : "All time"}
                </span>
              </div>
              <div className="ach-stat">
                <span className="ach-stat-label">Total Calls</span>
                <span className="ach-stat-value ach-stat-value--highlight">{hData?.length ?? 0}</span>
              </div>
            </div>

            {/* Table */}
            <div className="ach-table-wrap">
              {historyLoading ? (
                <div className="ach-loading">
                  <div className="ach-spinner"/>
                  <p className="ach-loading-txt">Loading history…</p>
                </div>
              ) : (
                <table className="ach-table">
                  <thead>
                    {table.getHeaderGroups().map((hg) => (
                      <tr key={hg.id}>
                        {hg.headers.map((h) => (
                          <th
                            key={h.id}
                            colSpan={h.colSpan}
                            onClick={h.column.getCanSort() ? h.column.getToggleSortingHandler() : undefined}
                            className={`ach-thead-th${h.column.getCanSort() ? " ach-thead-th--sort" : ""}`}
                          >
                            <div className="ach-th-inner">
                              {flexRender(h.column.columnDef.header, h.getContext())}
                              {h.column.getCanSort() && (
                                <span className="ach-sort-icon">
                                  {h.column.getIsSorted() === "asc" ? <BsArrowUp size={11}/> : h.column.getIsSorted() === "desc" ? <BsArrowDown size={11}/> : <RiArrowUpDownFill size={11}/>}
                                </span>
                              )}
                            </div>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {table.getRowModel().rows.length > 0 ? (
                      table.getRowModel().rows.map((row, ri) => (
                        <tr key={row.id} className={`ach-tbody-tr${ri % 2 !== 0 ? " ach-tbody-tr--alt" : ""}`}>
                          {row.getVisibleCells().map((cell) => (
                            <td key={cell.id} className="ach-tbody-td">
                              {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan={5}>
                        <div className="ach-empty">
                          <div className="ach-empty-icon"><TbHistory size={22}/></div>
                          <p className="ach-empty-title">No call history found</p>
                          <p className="ach-empty-sub">Try adjusting the date filter</p>
                        </div>
                      </td></tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {/* Footer */}
          <div className="ach-footer">
            <span className="ach-footer-hint">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              Showing API calls for this token
            </span>
            <button className="ach-btn-close" onClick={handleClose}>Close</button>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .ach-trigger-btn {
          width: 30px; height: 30px; border-radius: 8px;
          background: #eff6ff; border: 1.5px solid #bfdbfe; color: #2563eb;
          cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all .15s;
        }
        .ach-trigger-btn:hover { background: #dbeafe; border-color: #93c5fd; }

        .ach-panel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; top: 0; right: 0; bottom: 0;
          width: 100%; max-width: 680px;
          background: #fff; z-index: 1004;
          display: flex; flex-direction: column;
          box-shadow: -12px 0 60px rgba(15,23,42,.18);
          transition: transform .35s cubic-bezier(0.16,1,0.3,1);
        }
        .ach-panel--open  { transform: translateX(0); }
        .ach-panel--close { transform: translateX(100%); }

        .ach-top-glow {
          height: 3px; flex-shrink: 0;
          background: linear-gradient(90deg,#1e3a8a,#2563eb,#7c3aed,#2563eb,#1e3a8a);
          background-size: 200% 100%;
          animation: achGlow 3s linear infinite;
        }
        @keyframes achGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .ach-header {
          padding: 15px 26px;
          background: linear-gradient(135deg,#1e3a8a 0%,#1d4ed8 60%,#2563eb 100%);
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .ach-header-brand { display: flex; align-items: center; gap: 13px; }
        .ach-header-logo {
          width: 42px; height: 42px; border-radius: 12px;
          background: rgba(255,255,255,.15); border: 1.5px solid rgba(255,255,255,.25);
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        }
        .ach-header-title { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -.3px; margin-bottom: 2px; line-height: 1; }
        .ach-header-sub { font-size: 12px; color: rgba(255,255,255,.55); font-weight: 500; }
        .ach-close-btn {
          background: none; border: none; cursor: pointer;
          color: rgba(255,255,255,.65); display: flex; align-items: center; transition: color .15s;
        }
        .ach-close-btn:hover { color: #fff; }

        .ach-body { flex: 1; overflow-y: auto; overflow-x: hidden; padding: 20px 24px; display: flex; flex-direction: column; gap: 16px; }
        .ach-body::-webkit-scrollbar { width: 4px; }
        .ach-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* Filters */
        .ach-filters { display: flex; flex-direction: column; gap: 10px; }
        .ach-filter-section { display: flex; align-items: flex-start; gap: 14px; }
        .ach-filter-icon {
          width: 38px; height: 38px; border-radius: 10px; flex-shrink: 0;
          background: linear-gradient(135deg,#eff6ff,#dbeafe); border: 1.5px solid #bfdbfe;
          display: flex; align-items: center; justify-content: center; color: #2563eb; margin-top: 2px;
        }
        .ach-filter-content { flex: 1; display: flex; flex-direction: column; gap: 6px; }
        .ach-filter-label { font-size: 12.5px; font-weight: 700; color: #374151; }
        .ach-datepicker-wrap .react-datepicker-wrapper { width: 100%; }
        .ach-datepicker {
          width: 100%; padding: 11px 14px;
          background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 11px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; color: #0f172a;
          outline: none; transition: border-color .18s; box-sizing: border-box;
        }
        .ach-datepicker:focus { border-color: #2563eb; background: #fff; box-shadow: 0 0 0 3px rgba(37,99,235,.1); }

        /* Stats */
        .ach-stats {
          display: flex; align-items: center; gap: 0;
          background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; 
        }
        .ach-stat {
          flex: 1; padding: 12px 16px; display: flex; flex-direction: column; gap: 3px;
          border-right: 1px solid #e2e8f0;
        }
        .ach-stat:last-child { border-right: none; }
        .ach-stat-label { font-size: 10.5px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.5px; }
        .ach-stat-value { font-size: 13px; font-weight: 700; color: #0f172a; }
        .ach-stat-value--highlight { color: #2563eb; }

        /* Table */
        .ach-table-wrap { overflow-x: auto; border: 1px solid #e2e8f0; border-radius: 12px;scrollbar-width: none;-ms-overflow-style: none;  }
        .ach-table-wrap::-webkit-scrollbar { display: none; }
        .ach-table { width: 100%; border-collapse: collapse; }
        .ach-thead-th { padding: 10px 14px 8px; background: #f8fafc; border-bottom: 1.5px solid #e2e8f0; text-align: left; white-space: nowrap; user-select: none; }
        .ach-thead-th--sort { cursor: pointer; }
        .ach-thead-th--sort:hover { background: #f1f5f9; }
        .ach-th-inner { display: flex; align-items: center; gap: 5px; }
        .ach-th { font-size: 11px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: 0.5px; }
        .ach-sort-icon { color: #94a3b8; display: flex; align-items: center; }
        .ach-tbody-tr { transition: background .12s; }
        .ach-tbody-tr:hover { background: #f8fafc; }
        .ach-tbody-tr--alt { background: #fafbfc; }
        .ach-tbody-td { padding: 11px 14px; border-bottom: 1px solid #f1f5f9; }
        .ach-cell-text { font-size: 12.5px; font-weight: 600; color: #0f172a; }
        .ach-api-name { font-size: 12.5px; font-weight: 600; color: #475569; text-transform: capitalize; }

        .ach-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 32px; gap: 8px; }
        .ach-empty-icon { width: 44px; height: 44px; border-radius: 11px; background: #f8fafc; border: 1.5px solid #e2e8f0; display: flex; align-items: center; justify-content: center; color: #cbd5e1; }
        .ach-empty-title { font-size: 13px; font-weight: 700; color: #64748b; }
        .ach-empty-sub { font-size: 12px; color: #94a3b8; }

        .ach-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px; gap: 10px; }
        .ach-spinner { width: 24px; height: 24px; border: 2.5px solid #e2e8f0; border-top-color: #2563eb; border-radius: 50%; animation: achSpin .7s linear infinite; }
        @keyframes achSpin { to { transform: rotate(360deg); } }
        .ach-loading-txt { font-size: 12.5px; color: #94a3b8; font-weight: 500; }

        .ach-footer {
          padding: 12px 24px; border-top: 1px solid #f1f5f9; background: #fafbfc;
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .ach-footer-hint { display: flex; align-items: center; gap: 5px; font-size: 12px; color: #94a3b8; font-weight: 500; }
        .ach-btn-close {
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; color: #64748b;
          padding: 8px 16px; border-radius: 9px; border: 1.5px solid #e2e8f0; background: #fff;
          cursor: pointer; transition: all .15s;
        }
        .ach-btn-close:hover { background: #f1f5f9; color: #374151; }

        @media (max-width: 640px) {
          .ach-panel { max-width: 100%; }
          .ach-header, .ach-body, .ach-footer { padding-left: 18px; padding-right: 18px; }
        }
      `}</style>
    </>
  );
}

export default CrerateAPIAccessFilter;